import Guard from 'arg-guard'

import Store from '../store'

/**
 * Defined structure of an application error.
 *
 * @export AppError
 * @class AppError
 */
export default class AppError {

    /**
     * Creates an instance of AppError.
     * @param {string} message
     * @param {boolean} [allowReporting=false]
     * @memberof AppError
     */
    constructor(message, allowReporting = false) {
        Guard.throwIf(message, 'message')

        this.message = message
        this.allowReporting = allowReporting
    }

    get state() {
        return {
            property: Store.state.property,
            authContext: Store.state.authContext,
            savingsLoaded: Store.state.improvements && Store.state.improvements.savings && Store.state.improvements.savings.length > 0,
            addedImprovements: Store.state.improvements && Store.state.improvements.currentProject
                ? Store.state.improvements.currentProject.addedImprovements.map(imp => imp.toStoreJson()) : null,
            recommendedImprovements: Store.state.improvements && Store.state.improvements.currentProject
                ? Store.state.improvements.currentProject.recommendedImprovements.map(imp => imp.toStoreJson()) : null,
            currentProject: Store.state.improvements && Store.state.improvements.currentProject
                ? Store.state.improvements.currentProject.toStoreJson() : null,
        }
    }

    /**
     * Converts the object to raw JSON.
     *
     * @returns {Object} Raw JSON.
     * @memberof AppError
     */
    toJson() {
        return {
            message: this.message,
            allowReporting: this.allowReporting,
            state: this.state,
        }
    }
}
